const angular = require('angular')

import { STYLEGUIDE_STATES } from './styleguide.states';

angular
  .module('spinnaker.core.styleguide', [STYLEGUIDE_STATES]);

export const STYLEGUIDE_MODULE = 'spinnaker.core.styleguide';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/styleguide/styleguide.module.ts